import AuthorTable from '../../WhiteHat/components/AuthorTable';
import {useState, useEffect, useMemo} from 'react';
import {Grid} from 'antd';
import {AuthorList} from "../../WhiteHat/components/AuthorList";
import {useQuery} from "react-query";
import {getTeamMembers} from "../../../api/Team";
import {useParams} from "react-router-dom";

const {useBreakpoint} = Grid

export const Members = () => {
    const breakpoint = useBreakpoint();
    const [page, setPage] = useState(1)
    const { title } = useParams();

    const {data, isLoading} = useQuery(['white-hat-members', page], () => getTeamMembers(title, page))

    const tableData = useMemo(() => data?.data?.list.map((item, index) => ({
        ...item,
        index
    })) ?? [], [data])

    const pageOptions = useMemo(() => {
        const {
            total = 0
        } = data?.data ?? {}
        return {
            total: total,
            perSize: 10,
        }
    }, [data])

    const isMobile = useMemo(() => {
        return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
    }, [breakpoint])

    const pagination = useMemo(() => ({
        showSizeChanger: false,
        showQuickJumper: false,
        total: pageOptions.total,
        current: page,
        pageSize: pageOptions.perSize,
        onChange: (page) => {
            setPage(page);
        },
    }), [setPage, page, pageOptions])

    return (
        <>
            {
                isMobile ? (
                    <AuthorList
                        data={tableData}
                        loading={isLoading}
                        pagination={pagination}
                        currentPage={page}
                    />
                ) : (
                    <AuthorTable
                        data={tableData}
                        loading={isLoading}
                        pagination={pagination}
                        currentPage={page}
                    />
                )
            }
        </>
    );
};
